<script>
  import MinimizedTasksView from "./MinimizedTasksView.svelte";
  import FullTaskView from "./FullTaskView.svelte";
  import ArchivedTasks from "./archivedTasks.svelte";
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import CreateTask from "../../components/createTask.svelte";
  import Redirect from "../../components/backDashboard.svelte";
  import { user } from "../../firebase";
  import { conversion, lang } from "../../store/store";
  export let createTask;
  let tasks = [];
  $user.tasks.subscribe((v) => {
    tasks = Object.entries(v);
  });

  //TO DO ANIMATION
  onMount(() => {
    delaying = 0;
    setInterval(() => {
      delaying = 300;
    }, 200);
  });

  let delaying;
  let x = "Boards";
  let src = "./logo.png";

  let title = $conversion[$lang].MyTasks.title;
</script>

<div
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
  class="contentWrapper"
>
  {#if tasks.length > 0}
    <div class="mainContent">
      <div class="tasksContainer">
        <div class="dashboard">
          <i class="bx bx-left-arrow-alt" />
          <a href="/">
            <h5>{$conversion[$lang].backDashboard.back}</h5>
          </a>
        </div>
        <div class="TitleContainer">
          <div class="text">
            <h1>{$conversion[$lang].backDashboard.title.task}</h1>
          </div>
          <div class="task-view">
            <div
              style="margin-right:1.25rem"
              on:click={() => {
                x = "Boards";
              }}
              class:selected={x == "Boards"}
              class="t-Title slide-center-out"
            >
              <div class="slide-center-out">
                {$conversion[$lang].MyTasks.headings[1]}
              </div>
            </div>
            <div
              on:click={() => {
                x = "List";
              }}
              class:selected={x == "List"}
              class="t-Title slide-center-out"
            >
              <div class="slide-center-out">
                {$conversion[$lang].MyTasks.headings[2]}
              </div>
            </div>

            <div
              style="margin-left:auto"
              on:click={() => {
                x = "Archive";
              }}
              class:selected={x == "Archive"}
              class="t-Title slide-center-out"
            >
              <div class="slide-center-out">
                {$conversion[$lang].MyTasks.headings[3]}
              </div>
            </div>
          </div>
        </div>
      </div>

      {#if x == "List"}
        <div
          style="position:absolute"
          in:fade={{ duration: 300, delay: 300 }}
          out:fade={{ duration: 300, delay: 0 }}
          id="FulltaskView"
          class="AlltasksContainer absolute"
        >
          <FullTaskView />
        </div>
      {:else if x == "Archive"}
        <div
          class="absolute"
          in:fade={{ duration: 300, delay: 300 }}
          out:fade={{ duration: 300, delay: 0 }}
        >
          <ArchivedTasks />
        </div>
      {:else}
        <div
          class="absolute"
          in:fade={{ duration: 300, delay: 300 }}
          out:fade={{ duration: 300, delay: 0 }}
        >
          <MinimizedTasksView bind:createTask />
        </div>
      {/if}
    </div>
  {:else}
    <Redirect bind:title />
    <div class="wrapper">
      <div class="tasks-ctn">
        <div class="tasks-txt">{$conversion[$lang].MyTasks.noTasksmsg}</div>
        <div
          on:click={() => {
            createTask = true;
          }}
          class="tasks-btn"
        >
          <!--the tasks=["1"] is just to test how the page changes-->
          {$conversion[$lang].MyTasks.ctaButton}
        </div>
      </div>
    </div>
  {/if}
  <!-- svelte-ignore a11y-missing-attribute -->
  <!-- <img {src} /> -->
</div>

<style>
  ::-webkit-scrollbar {
    height: 3.5px;
    width: 3px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  a {
    color: #333;
  }

  * {
    padding: 0;
    margin: 0;
  }

  h1 {
    margin: 0;
    padding: 0;
  }

  .contentWrapper {
    height: 100vh;
    width: 95%;
    max-width: 1350px;
  }

  .wrapper {
    display: flex;
    justify-content: center;
  }

  .tasksContainer {
    /* background: grey; */
    padding-top: 1rem;
    padding-bottom: 20px;
  }

  .dashboard {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
  }

  .dashboard h5 {
    margin: 0;
    font-weight: 800;
  }

  .TitleContainer {
    /* display: flex;
        align-items: center;
        justify-content: space-between; */
    display: flex;
    flex-direction: column;
    /* background-color: green; */
  }

  .absolute {
    position: absolute;
    width: 95%;
    max-width: 1350px;
  }

  .icons {
    display: flex;
    align-items: center;
    margin: 0 auto;
    /* background-color: red; */
  }

  .text {
    display: flex;
    align-items: center;
    font-family: "Poppins", sans-serif;
  }

  .text h1 {
    font-weight: 500 !important;
    margin: 0;
  }

  .selected {
  }

  .AlltasksContainer {
    /* background: red; */
    padding-right: 2rem;
    max-height: 70vh;
    overflow-x: hidden;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(44, 143, 115, 0.35);
  }

  .animationTrigger {
    transition: all 0.3s ease-in-out;
    /* opacity: 0; */
  }

  .tasks-ctn {
    position: absolute;
    width: 95%;
    max-width: 1350px;
    background: rgba(229, 234, 240, 0.71);
    border-radius: 18px;
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .tasks-txt {
    font-size: 1.2em;
    font-weight: 500;
    color: black;
    text-align: center;
  }

  .tasks-btn {
    margin-top: 2rem;
    padding: 0.5rem 1rem;
    color: #2c8f73;
    border: 1px solid #2c8f73;
    border-radius: 8px;
    background-color: transparent;
    font-weight: 500;
    cursor: pointer;
  }
  .bx-left-arrow-alt {
    font-size: 1.3em;
  }

  .task-view {
    display: flex;
    border-bottom: rgba(132, 141, 155, 0.53) 2.5px solid;
    margin-top: 0.5rem;
  }

  .t-Title {
    font-weight: 400;
    color: #848d9b;
    font-size: 1.1em;
    cursor: pointer;
  }

  .slide-center-out {
    text-decoration: none;
    display: inline-block;
  }

  .slide-center-out:after {
    content: "";
    display: block;
    /* padding: 0 0rem; */
    height: 2.5px;
    width: 0;
    background: var(--primaryColor);
    transition: width 0.4s cubic-bezier(0.45, 0, 0.55, 1);
    margin: auto;
    margin-top: 10px;
    margin-bottom: -7.5px;
  }

  .selected {
    color: black;
    font-weight: 500;
    transition: all 0.4s ease;
  }

  .selected .slide-center-out:after {
    width: 100%;
  }

  .display {
    display: flex;
  }

  .none {
    display: none;
  }
</style>
